"use client";

import { usePathname } from "next/navigation";
import { useMemo } from "react";
import { APP_ROUTES } from "~/constants/appRoutes";

const EXCLUDE_URL_LIST: string[] = [
    APP_ROUTES.PQP_HORMONE_IMBALANCE,
    APP_ROUTES.PQP_ANTI_AGING_FACE_CREAM,
    APP_ROUTES.THANK_YOU,
];

export function useRouteFlags() {
    const pathname = usePathname();

    return useMemo(() => {
        const hideGetStartedLink = EXCLUDE_URL_LIST.includes(pathname);
        const isThankYou = pathname === APP_ROUTES.THANK_YOU;

        return {
            pathname,
            hideGetStartedLink,
            isThankYou,
        };
    }, [pathname]);
}
